import styled from "@emotion/styled";
import colors from "/styles/colors";
export const StyledBackgroundColorThumbnailItemComponent = styled.a`
  background: green;
  position: relative;
  height: 350px;
  width: 300px;
  margin: 20px;
  transition: 0.2s ease-in-out all;
  text-decoration: none;

  &:hover {
    transform: scale(1.03);
    cursor: pointer;
  }

  .thumbnail-title {
    color: ${colors["white"]};
    font-size: 1.688rem;
    padding: 30px;
  }
`;
